import { Injectable } from '@angular/core';
import { TranslationFromJsonService } from '@shared/feature/translate';
import { Observable, Subject } from 'rxjs';
import { MessageType, NotificationModel } from '../models/notification.models';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private errorSubject = new Subject<NotificationModel>();

  constructor(private translate: TranslationFromJsonService, private messageService: MessageService) {}

  notifications(): Observable<NotificationModel> {
    return this.errorSubject;
  }

  show(model: NotificationModel): void {
    const detail = this.translate.instant(model.message);
    const summary = model.summary || model.type.charAt(0).toUpperCase() + model.type.slice(1).toLowerCase();
    const icon = model.icon;
    const life = model.life ?? 5000;

    this.messageService.add({
      severity: model.type,
      summary,
      detail,
      icon,
      life,
    });

    this.errorSubject.next(model);
  }

  addError(message: string, summary?: string): void {
    this.show(new NotificationModel(message, MessageType.Danger, summary));
  }

  addSuccess(message: string, summary?: string): void {
    this.show(new NotificationModel(message, MessageType.Success, summary));
  }

  addWarning(message: string, summary?: string): void {
    this.show(new NotificationModel(message, MessageType.Warning, summary));
  }

  addInfo(message: string, summary?: string): void {
    this.show(new NotificationModel(message, MessageType.Info, summary));
  }
}
